import useUpdateUserCache from './useUpdateUserCache'

export default useUpdateUserCache
